<div style="width: 100%;">
  <canvas #chart id="horseStrides" width="700" height="150"></canvas>
</div>
